var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.0972 0.999506L2.00097 9.0957L10.0972 17.1919","stroke":"currentColor","strokeWidth":"1.7615"}));
}

ChevronLeft.defaultProps = {"width":"11","height":"18","viewBox":"0 0 11 18","fill":"none"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
